import AUTOMATION from "./Assets/Projects/3automation.jpg";
import COAST from "./Assets/Projects/coast.jpg";
import DROPSHIP from "./Assets/Projects/dropship.jpg";
import GOOD_FOOD_DISCOUNTS from "./Assets/Projects/goodFoodDiscounts.png";
import GUAMEDIA from "./Assets/Projects/guamedia.jpg";
import HSP from "./Assets/Projects/hsp.png";
import COSMOS from "./Assets/Projects/cosmos.jpg";
import TECHSPEC from "./Assets/Projects/techspec.png";
import TRAVELWELL from "./Assets/Projects/travelwell.png";


export const PROJECTS = [
  {
    image: COSMOS,
    name: "Micorsoft Azure Cosmos DB",
    technologyUsed: "ReactJs, Javascript, Redux, knockout.js, Jest",
    description: "Azure Cosmos DB is Microsoft's proprietary globally distributed, multi-model database service 'for managing data at planet-scale' Azure Cosmos DB is a fully managed NoSQL database for modern app development. Single-digit millisecond response times, and automatic and instant scalability, guarantee speed at any scale.",
    url: "https://cosmos.azure.com/",
  },
  {
    image: TRAVELWELL,
    name: "travlwell.com",
    technologyUsed: "Shopify, React, typescript, polaris, GraphQL",
    description: "Custom Luggage Tags and Passport Holders engraved with everywhere you've traveled and everywhere you will travel in the future.",
    url: "https://travlwell.com/",
  },
  {
    image: COAST,
    name: "Coast",
    technologyUsed: "ReactNative, Javascript, Redux",
    description: "Team collaboration mobile app and online services like slack Message people and groups without sharing phone numbers, communicate with managers and staff all in one place. and discuss or assign tasks to get stuff done",
    url: "https://play.google.com/store/apps/details?id=com.fomo.android.app",
  },
  {
    image: AUTOMATION,
    name: "3automation.com (RPA)",
    technologyUsed: "ReactJs, Typescript, Redux",
    description: "The next-gen Robotic Process Automation (#RPA) platform for retail and telecom domains. The ultimate automation platform for your Shopify, Email, E- commerce shop",
    url: "https://www.3automation.com/",
  },
  {
    image: GUAMEDIA,
    name: "GuaMedia",
    technologyUsed: "ReactNative, Javascript, Redux",
    description: "Social media mobile app similar to Twitter for china. Social networking GUOMEDIA is an all-in-one social networking platform where users can build their own user profiles, create their own posts, Livestream broadcast and follow each other",
    url: "https://play.google.com/store/apps/details?id=com.tiu.guo.media",
  },
  {
    image: TECHSPEC,
    name: "TechSpec",
    technologyUsed: "ReactJs, Typescript, Redux",
    description: "TechSpec is e-commerce web app. User can compare his product and purchange. This had a dashboard web app which had the data of orders placed and type of user.",
    url: "",
  },
  {
    image: HSP,
    name: "HSP (Health Solution Plus)",
    technologyUsed: "ReactJs, Javascript, Redux",
    description: "This is a Healthcare sector project which would be developed as replica of a desktop application. My responsibilities in this project are to develop UI, perform searching of medical codes and categories, addition/updation of codes and categories.",
    url: "",
  },
  {
    image: DROPSHIP,
    name: "DropShip Shopify App",
    technologyUsed: "Shopify, React, typescript, polaris, GraphQL, Nodejs, Koajs",
    description: "It is customized clothes shopify app which fetch order from store and give option to customize product and send detail to store owner. Also maintain tracking etc of product.",
    url: "",
  },
  {
    image: GOOD_FOOD_DISCOUNTS,
    name: "GoodFoodDiscounts",
    technologyUsed: "ReactNative, Javascript, Redux",
    description: "Good food discouts app is similar like swiggy. Food and hotel can be searched and can be order. Even has facility to add coupan. You can add food in favourite list.",
    url: "",
  },
];

export const SKILLS = [
  { name: "React", initialRating: 4 },
  // { name: "React-Native", initialRating: 4 },
  { name: "JavaScript", initialRating: 5 },
  { name: "Python", initialRating: 4 },
  // { name: "Shopify/Reactjs", initialRating: 4 },
  // { name: "Nodejs", initialRating: 3 },
  // { name: "Koajs", initialRating: 3 },
  { name: "HTML", initialRating: 4 },
  { name: "CSS", initialRating: 4 },
  // { name: "Unit-Testing(Jest)", initialRating: 3 },
  // { name: "TypeScript", initialRating: 4 },
  // { name: "Graphql", initialRating: 4 },
  // { name: "Apollo", initialRating: 4 },
  // { name: "AntD | ReactStrap | Material UI", initialRating: 4 },
  // { name: "Shopify Polaris", initialRating: 4 },
  { name: "Java", initialRating: 4 },
  { name: "jQuery", initialRating: 3 },
  { name: "JSON", initialRating: 3 },
  { name: "Angular JS", initialRating: 2 },
  { name: "SQL", initialRating: 3 },
  { name: "Git,Scrum", initialRating: 5 },
  { name: "Agile", initialRating: 5 },
  { name: "UX/UI", initialRating: 3 },
];

export const TOOLS = ["Visual Studio Code", "Git", "Chrome DevTools", "Npm (Node Package Manager)", "Atom", "Sublime Text", "Linux", "Heroku", "Postman", "PyCharm"]
